import { render, staticRenderFns } from "./register-new-patient.vue?vue&type=template&id=0e1d6869&"
import script from "./register-new-patient.vue?vue&type=script&lang=js&"
export * from "./register-new-patient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports